import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { selectors as PublicNotesSelectors } from 'data/publicNotes'
import { actions as PublicUIActions } from 'data/publicUI'

import List from './List'
import { ChannelStructureLayout } from 'components/Public/Layout'

export default function StructurePanel({ publicChannel }) {
  useParentNoteExpander()
  return (
    <ChannelStructureLayout>
      <div
        className="flexbox-no-shrink  flexbox flexbox-align-center shade-05 bold padding-left-large ellipsis"
        style={{ fontSize: 16, height: 60 }}
      >
        {publicChannel.name}
      </div>
      <List
        channelId={publicChannel.id}
        publicShareToken={publicChannel.publicShareToken}
      />
    </ChannelStructureLayout>
  )
}

function useParentNoteExpander() {
  let activeNotePathIds = useSelector(
    PublicNotesSelectors.getActiveNoteAncestorsIds
  )

  const activeNote = useSelector(PublicNotesSelectors.getActiveNote)
  if (activeNote && activeNote.hasChildren) {
    activeNotePathIds = [...activeNotePathIds, activeNote.id]
  }

  const activeNotePathAsString = activeNotePathIds.join('-')

  const dispatch = useDispatch()
  React.useEffect(
    () => {
      dispatch(PublicUIActions.expandNotes({ noteIds: activeNotePathIds }))
      return () => {
        dispatch(PublicUIActions.expandNotes({ noteIds: [] }))
      }
    },
    // ignore the issue in the array on purpose:
    // we convert/hash the activeNotePathIds to a string as comparing arrays does not work
    // as suggested in https://github.com/facebook/react/issues/14324#issuecomment-441489421
    // Spreading the array isn't a proper solution
    // (cf. https://stackoverflow.com/questions/57607252/useeffect-warning-when-adding-dependencies-using-spread-operator)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, activeNotePathAsString]
  )
}
